import { Button, ButtonProps, CircularProgress, styled } from '@mui/material';
import { memo } from 'react';

export interface ButtonWithLoaderProps extends ButtonProps {
    loading?: boolean;
}

function ButtonWithLoader({ loading, children, ...rest }: ButtonWithLoaderProps) {
    return (
        <Root loading={ loading }
            { ...rest }
        >
            {
                loading
                    ? <CircularProgress size={ 24 }
                        color="inherit" />
                    : children
            }
        </Root>
    );
}

const Root = styled(Button, {
    shouldForwardProp: (prop) => prop !== 'loading'
})<{ loading?: boolean }>(({ loading }) => ({
    ...(loading ? {
        pointerEvents: 'none',
        cursor: 'not-allowed'
    } : {})
}));

export default memo(ButtonWithLoader);
